/*
 * File: pages/AdminDashboard.js
 * Mô tả: Trang tổng quan quản trị viên với Sidebar đa cấp (Multi-level Accordion).
 * Cập nhật: Gom toàn bộ tab con của các phân hệ vào Menu bên trái.
 */
import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation, Navigate, useNavigate } from 'react-router-dom';

import EmployeeManagement from '../components/admin/EmployeeManagement';
import LeaveAdministration from '../components/leave/LeaveAdministration';
import PayrollManagement from '../components/admin/PayrollManagement';
import TimesheetModule from '../components/timesheet/TimesheetModule';
import PayrollPage from './Salary/PayrollPage';
import AdminNotifications from '../components/admin/AdminNotifications';
import AdminOverview from '../components/admin/AdminOverview'; // <-- MỚI: Import trang Tổng quan

const Icons = {
    Menu: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>,
    Users: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    Calendar: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/><path d="m9 16 2 2 4-4"/></svg>,
    Wallet: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>,
    Calculator: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="16" height="20" x="4" y="2" rx="2"/><line x1="8" x2="16" y1="6" y2="6"/><line x1="16" x2="16" y1="14" y2="18"/><path d="M16 10h.01"/><path d="M12 10h.01"/><path d="M8 10h.01"/><path d="M12 14h.01"/><path d="M8 14h.01"/><path d="M12 18h.01"/><path d="M8 18h.01"/></svg>,
    Clock: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
    Bell: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>,
    Logout: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg>,
    ChevronDown: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
    Dashboard: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1"></rect><rect x="14" y="3" width="7" height="5" rx="1"></rect><rect x="14" y="12" width="7" height="9" rx="1"></rect><rect x="3" y="16" width="7" height="5" rx="1"></rect></svg>
};

const navItems = [
    {
        path: '/overview', label: 'Tổng quan', icon: Icons.Dashboard // <-- MỚI: Thêm menu Tổng quan lên đầu tiên
    },
    {
        path: '/employee', label: 'Quản lý Nhân viên', icon: Icons.Users,
        subItems: [
            { path: '/employee?tab=list', label: 'Danh sách & Sửa/Xóa' },
            { path: '/employee?tab=add', label: 'Thêm Nhân viên Mới' },
            { path: '/employee?tab=check', label: 'Kiểm tra Thông tin' },
            { path: '/employee?tab=manage', label: 'Quản lý Tài khoản' },
            { path: '/employee?tab=basic_code', label: 'Quản lý Mã Chung' },
            { path: '/employee?tab=mapping', label: 'Quản lý Mã Chấm Công' },
        ]
    },
    {
        path: '/leave', label: 'Quản lý Phép', icon: Icons.Calendar,
        subItems: [
            { path: '/leave?tab=manage', label: 'Nhập / Sửa / Xóa Phép' },
            { path: '/leave?tab=config', label: 'Cấu hình Phép (Upload)' },
            { path: '/leave?tab=advanced', label: 'Thanh Toán Phép Năm' },
        ]
    },
    {
        path: '/timesheet', label: 'Quản lý Chấm công', icon: Icons.Clock,
        subItems: [
            { path: '/timesheet/upload', label: 'Upload Chấm Công' },
            { path: '/timesheet/query', label: 'Tra cứu & Sửa chữa' },
            { path: '/timesheet/log', label: 'Nhập Công Lẻ' },
            { path: '/timesheet/report', label: 'Báo cáo Chấm công' }
        ]
    },
    {
        path: '/salary-management', label: 'Tính Lương Tháng', icon: Icons.Calculator,
        subItems: [
            { path: '/salary-management/basic', label: 'Lương Cơ Bản' },
            { path: '/salary-management/insurance', label: 'BHXH & Công đoàn' },
            { path: '/salary-management/relief', label: 'Giảm Trừ Gia Cảnh' },
            { path: '/salary-management/overtime', label: 'Lương Tăng Ca' },
            { path: '/salary-management/calculate', label: 'Tính Lương' },
            { path: '/salary-management/export', label: 'Xuất Excel Lương' }
        ]
    },
    {
        path: '/payroll', label: 'Báo cáo & Duyệt Lương', icon: Icons.Wallet,
        subItems: [
            { path: '/payroll?tab=approve', label: 'Duyệt Lương Hàng Tháng' },
            { path: '/payroll?tab=bonus', label: 'Quản lý Lương Tháng 13' },
            { path: '/payroll?tab=deduction', label: 'Khấu Trừ Lương' },
            { path: '/payroll?tab=salary_basic', label: 'Quản lý Lương Cơ Bản' },
        ]
    },
    {
        path: '/notifications', label: 'Quản lý Thông báo', icon: Icons.Bell
    }
];

export default function AdminDashboard({ user, onLogout }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});

    // Đóng sidebar trên mobile khi chuyển trang
    useEffect(() => {
        setIsSidebarOpen(false);
    }, [location.pathname, location.search]);

    // Tự động mở menu cha nếu đang ở route con
    useEffect(() => {
        const activeParent = navItems.find(item => location.pathname.startsWith(item.path));
        if (activeParent && activeParent.subItems) {
            setExpandedMenus(prev => ({ ...prev, [activeParent.path]: true }));
        }
    }, [location.pathname]);

    const toggleMenu = (path, hasSubItems) => {
        if (hasSubItems) {
            setExpandedMenus(prev => ({ ...prev, [path]: !prev[path] }));
        } else {
            navigate(path);
        }
    };

    // Lấy tiêu đề trang hiện tại
    const activeParentItem = navItems.find(item => location.pathname.startsWith(item.path)) || navItems[0];
    const pageTitle = activeParentItem.label;

    return (
        <div className="flex w-full min-h-screen text-[#102a43]">
            <title>Dashboard Nhân Sự | Admin</title>

            {/* Mobile Sidebar Overlay */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 z-30 bg-slate-950/50 backdrop-blur-sm lg:hidden transition-opacity animate-fade-in"
                    onClick={() => setIsSidebarOpen(false)}
                ></div>
            )}

            {/* Sidebar Navigation */}
            <aside 
                className={`fixed lg:sticky top-0 left-0 z-40 flex flex-col h-screen shrink-0 w-[285px] bg-[#102a43] text-white p-5 transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
            >
                {/* Logo & Brand */}
                <header className="mb-9 flex items-center gap-3">
                    <div className="flex shrink-0 items-center justify-center w-[42px] h-[42px] rounded-xl bg-white shadow-[4px_4px_0_rgba(255,255,255,0.14)] overflow-hidden border border-white/20">
                        <img 
                            src="/logo.png" 
                            alt="Logo VINACAPA" 
                            className="w-full h-full object-contain p-0.5" 
                            onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/42x42/cccccc/333333?text=Logo'; }}
                        />
                    </div>
                    <div>
                        <p className="text-[11px] text-[#bcccdc] mt-0.5 uppercase tracking-wider">Công ty TNHH</p>
                        <p className="text-sm font-black tracking-wide text-white leading-tight uppercase">VINACAPA</p>
                    </div>
                </header>

                {/* Profile Widget */}
                <section className="mb-6 rounded-2xl p-4 bg-white/5 border border-white/10 shadow-sm">
                    <div className="flex items-center gap-3">
                        <div className="flex shrink-0 h-11 w-11 items-center justify-center rounded-full bg-[#c9f24d] font-bold text-slate-900 shadow-sm">
                            {user?.name ? user.name.charAt(0).toUpperCase() : 'A'}
                        </div>
                        <div className="min-w-0 flex-1">
                            {/* Đã xóa class 'truncate', thêm 'break-words' và 'leading-snug' để chữ rớt dòng đẹp mắt */}
                            <h2 className="font-bold text-sm text-white break-words leading-snug">{user?.name || 'Admin'}</h2>
                            <p className="mt-1 text-[11px] text-[#d9e2ec]">Quản trị hệ thống</p>
                        </div>
                    </div>
                </section>

                {/* Main Navigation - Accordion Style */}
                <nav className="flex-1 space-y-1.5 overflow-y-auto pr-2 scrollbar-hide">
                    {navItems.map(item => {
                        const isParentActive = location.pathname.startsWith(item.path);
                        const isExpanded = expandedMenus[item.path];
                        const hasSubItems = item.subItems && item.subItems.length > 0;

                        return (
                            <div key={item.path} className="flex flex-col">
                                {/* Nút cha */}
                                <button 
                                    onClick={() => toggleMenu(item.path, hasSubItems)}
                                    className={`flex items-center justify-between w-full rounded-xl px-3.5 py-3 text-sm transition-all duration-200 ${
                                        isParentActive && !hasSubItems
                                        ? 'bg-[#c9f24d]/15 text-[#e5ff9b] font-bold border border-[#c9f24d]/20' 
                                        : 'text-[#bcccdc] font-medium hover:bg-white/5 hover:text-white border border-transparent'
                                    }`}
                                >
                                    <div className="flex items-center gap-3">
                                        <span className={isParentActive ? 'text-[#c9f24d]' : 'text-[#bcccdc]'}>
                                            <item.icon />
                                        </span>
                                        {item.label}
                                    </div>
                                    {hasSubItems && (
                                        <span className={`transition-transform duration-200 opacity-60 ${isExpanded ? 'rotate-180' : 'rotate-0'}`}>
                                            <Icons.ChevronDown />
                                        </span>
                                    )}
                                </button>

                                {/* Các menu con cấp 2 */}
                                {hasSubItems && (
                                    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isExpanded ? 'max-h-96 opacity-100 mt-1' : 'max-h-0 opacity-0'}`}>
                                        <div className="flex flex-col space-y-1 pl-10 border-l border-white/10 ml-[23px] py-1">
                                            {item.subItems.map(sub => {
                                                // Kiểm tra Active cho cấp 2 bằng cách so sánh chuẩn xác Path & Query
                                                const fullUrl = location.pathname + location.search;
                                                const isSubActive = fullUrl === sub.path || (sub.path.includes('?') && fullUrl.includes(sub.path.split('?')[1]));

                                                return (
                                                    <Link 
                                                        key={sub.path}
                                                        to={sub.path}
                                                        className={`block rounded-lg px-3 py-2 text-xs transition-colors relative ${
                                                            isSubActive 
                                                            ? 'text-white font-bold bg-white/10' 
                                                            : 'text-[#9fb3c8] font-medium hover:text-white hover:bg-white/5'
                                                        }`}
                                                    >
                                                        {isSubActive && <span className="absolute left-[-13px] top-[14px] w-1.5 h-1.5 rounded-full bg-[#c9f24d]"></span>}
                                                        {sub.label}
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </nav>

                <footer className="mt-6 border-t border-white/10 pt-5 text-center">
                    <p className="text-[10px] leading-relaxed text-[#9fb3c8]">Hệ thống vận hành Nội bộ<br/>© 2026 Công ty TNHH VINACAPA</p>
                </footer>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1 flex flex-col min-w-0 min-h-screen content-grid relative">
                {/* Header Top */}
                <header className="sticky top-0 z-20 flex w-full items-center justify-between gap-4 px-4 py-4 sm:px-7 sm:py-6 bg-[#f3f6f4]/90 backdrop-blur-md border-b border-gray-200/50">
                    <div className="flex items-center gap-3">
                        <button 
                            type="button" 
                            className="rounded-xl bg-white p-2.5 text-slate-700 shadow-sm border border-gray-200 lg:hidden active:scale-95 transition" 
                            onClick={() => setIsSidebarOpen(true)}
                        >
                            <Icons.Menu />
                        </button>
                        <div>
                            <p className="text-[10px] sm:text-xs font-bold uppercase tracking-widest text-[#147d64] mb-1">
                                Trung tâm điều hành
                            </p>
                            <h1 className="text-xl sm:text-2xl font-black text-[#102a43] tracking-tight">
                                {pageTitle}
                            </h1>
                        </div>
                    </div>
                    
                    <button 
                        onClick={onLogout}
                        className="flex items-center gap-2 rounded-xl bg-white px-4 py-2 text-sm font-bold text-rose-600 shadow-sm border border-rose-100 hover:bg-rose-50 transition"
                    >
                        <span className="hidden sm:inline">Đăng xuất</span>
                        <Icons.Logout />
                    </button>
                </header>

                {/* Routing Content */}
                <div className="flex-1 p-4 sm:p-7 overflow-x-hidden">
                    <div className="mx-auto w-full max-w-7xl">
                        {/* Bọc nền trắng cho tất cả các trang, NGOẠI TRỪ trang Tổng Quan */}
                        <div className={location.pathname.includes('/overview') ? "" : "bg-white rounded-3xl shadow-[0_12px_28px_rgba(16,42,67,0.04)] border border-slate-100 p-4 sm:p-6 min-h-[75vh]"}>
                            <Routes>
                                <Route path="overview" element={<AdminOverview />} />
                                <Route path="employee" element={<EmployeeManagement />} />
                                <Route path="leave" element={<LeaveAdministration />} />
                                <Route path="payroll" element={<PayrollManagement />} />
                                <Route path="salary-management/*" element={<PayrollPage />} />
                                <Route path="timesheet/*" element={<TimesheetModule />} />
                                <Route path="notifications" element={<AdminNotifications />} />
                                <Route index element={<Navigate to="overview" replace />} />
                                <Route path="*" element={<Navigate to="overview" replace />} />
                            </Routes>
                        </div>
                    </div>
                </div>
            </main>

            {/* Global CSS cho nền hạt & hiệu ứng */}
            <style>{`
                .content-grid {
                    background-color: #f3f6f4;
                    background-image: radial-gradient(#d9e2ec 1px, transparent 1px);
                    background-size: 20px 20px;
                }
                .scrollbar-hide::-webkit-scrollbar {
                    display: none;
                }
                .scrollbar-hide {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .admin-app-shell {
                    font-family: 'Work Sans', system-ui, -apple-system, sans-serif;
                }
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                .animate-fade-in {
                    animation: fadeIn 0.3s ease-out forwards;
                }
            `}</style>
        </div>
    );
}